export const FooterDesktop = () => (
  <div className="absolute flex w-full justify-end pr-8">
    <div className="fixed bottom-0 flex gap-x-2" />
  </div>
);
